/* eslint-disable react/no-unescaped-entities */
/* eslint-disable prettier/prettier */
import React from 'react'
import { Step } from 'react-joyride'

export const welcomeGuidedTour: Step[] = [
	{
		content: (
			<div>
				<p style={{ marginBottom: '16px' }}>
					Bem-vindo ao <strong>Tour Explicativo</strong> da Decorando a Lei
					Seca!
				</p>
				<p>
					Vamos te guiar em um passeio para entender a plataforma. Vamos lá?
				</p>
			</div>
		),
		locale: {
			skip: <strong aria-label='skip'>Cancelar</strong>,
			next: <strong aria-label='next'>Avançar</strong>,
		},
		target: 'body',
		placement: 'center',
		showSkipButton: true,
	},
	{
		content: (
			<div>
				<p style={{ marginBottom: '16px', textAlign: 'justify' }}>
					Para começar, saiba que o "coração" de nossa plataforma é o{' '}
					<strong>Vade Mecum de Questões</strong>, uma lista com milhares de
					questões sobre diversas leis para você testar seu conhecimento.
				</p>

				<p style={{ textAlign: 'justify' }}>
					Além disso, temos questões filtradas por <strong>Simulados</strong>,
					por <strong>Disciplinas</strong> e também <strong>Cursos</strong>.
					Vamos ver cada menu primeiro.
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
		target: 'body',
		placement: 'center',
	},
	{
		target: '.dashboard',
		content: (
			<div>
				<p>
					<strong>Dashboard</strong> permite ver seu <strong>desempenho</strong>
					, como quantas questões resolveu, quantas acertou ou errou, entre
					outras estatísticas da sua jornada.
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.vade-mecum-de-questoes',
		content: (
			<div>
				<p>
					Aqui, você acessa o <strong>Vade Mecum de Questões</strong>, nosso
					questionário com <strong>milhares de questões</strong> sobre
					legislação. É onde você testará seus conhecimentos!
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.cadernos',
		content: (
			<div>
				<p>
					<strong>Cadernos</strong> permite criar e acessar listas com as
					questões que você quer guardar para estudar ou relembrar.
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.simulados',
		content: (
			<div>
				<p>
					<strong>Simulados</strong> são listas de questões para você fazer como
					treino ou prova, como se fosse um concurso real. No modo prova, você
					pode responder contra o tempo, testando ainda mais seu desempenho!
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.disciplinas',
		content: (
			<div>
				<p>
					<strong>Disciplinas</strong> são listas de questões selecionadas por
					temática, como o Código Civil, o Código Penal e outras áreas do
					Direito.
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.rankings',
		content: (
			<div>
				<p>
					<strong>Ranking</strong> é um espaço para destacar os usuários mais
					engajados (que mais respondem questões) na plataforma. Te desafiamos a
					chegar ao topo!
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.filtros-salvos',
		content: (
			<div>
				<p>
					Ao responder questões, você poderá salvar listas delas filtradas por
					Código/Lei, Cargo, Banca e outros critérios. Essas listas ficarão
					salvas aqui.
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.cursos',
		content: (
			<div>
				<p>
					<strong>Cursos</strong> é onde você encontra materiais em PDF como
					guias, mapas mentais e tudo o que precisa para estudar com nosso
					método. Navegue e descubra as opções!
				</p>
			</div>
		),
		locale: {
			next: <strong aria-label='next'>Avançar</strong>,
			back: <strong aria-label='next'>Voltar</strong>,
		},
	},
	{
		target: '.tour',
		content: (
			<div>
				<p>
					Por fim, voltamos ao <strong>Tour Explicativo.</strong> Parabéns! Você
					já sabe o que e onde encontrar na plataforma. Agora, é com você.
					Ótimos estudos!
				</p>
			</div>
		),
		locale: {
			back: <strong aria-label='next'>Voltar</strong>,
			last: <strong aria-label='last'>Concluir</strong>,
		},
	},
]
